import { render, staticRenderFns } from "./MultiselectDropdownItems.vue?vue&type=template&id=4d8f772f&scoped=true&"
import script from "./MultiselectDropdownItems.vue?vue&type=script&lang=js&"
export * from "./MultiselectDropdownItems.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectDropdownItems.vue?vue&type=style&index=0&id=4d8f772f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f772f",
  null
  
)

export default component.exports